import { OrderTableData } from '../../../OrdersPage/types';
import {
  CONTACT_CLIENT_NETWORK_TAG_ID,
  CONTACT_CLIENT_SOURCE_TAG_ID,
} from './constants';

// Тег включён на аптеке (source) или на сети (network)
export const hasContactClientTag = (data: OrderTableData): boolean =>
  Boolean(
    data?.sourceTags?.some((tag) => tag.id === CONTACT_CLIENT_SOURCE_TAG_ID) ||
      data?.networkTags?.some((tag) => tag.id === CONTACT_CLIENT_NETWORK_TAG_ID)
  );
